<template>
  <div class="cat-file">
    <div class="fileboxheader">
      <span>{{ headert }}</span>
      <img 
        v-if="isPreview"
        style="width:20px;height:20px" 
        src="@/assets/preview_file.png" 
        @click="preview"
      />
    </div>
    <div class="fileboxmain">
      <div class="fileboxbox" @click="upclick">
        <img :src="require(`@/assets/${mainup?'file':'upload'}.png`)" style="width:28px;height:28px" alt="" />
        <div v-if="mainup" class="fileboxtext">{{fileName}}</div>
        <div v-else class="fileboxtext">{{isCheck ? '未上传' : '点击上传'}}</div>
      </div>
    </div>
    <template v-if='isPdf'>
      <preview-handout :url="previewUrl" v-if="previewFlag" @close="close"></preview-handout>
    </template>
    <template v-else>
      <preview-image v-model="previewFlag" :imageUrl="previewUrl"></preview-image>
    </template>
  </div>
</template>

<script>
import previewHandout from '@/view/confirm/compoment/previewHandout.vue'
import previewImage from '@/view/confirm/compoment/previewImage.vue'
export default {
  name: "CatInput",
  components: {
    previewHandout,
    previewImage
  },
  props: {
    mainup: {       //文件路径
      type: String,
      default: "",
    },
    headert: {
      type: String,
      default: "",
    },
    rtest: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    showPassword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      previewFlag: false,
      previewUrl:'',
      destoryFlag: false
    }
  },
  computed: {
    isPdf: function() {
      return this.mainup ? this.mainup.toUpperCase().includes('PDF') : '' 
    },
    isImage: function() {
      return ['PNG','JPG','JPEG'].some(element => this.mainup.toUpperCase().includes(element))
    },
    isPreview: function() { //预览pdf类型的文件
      return this.mainup && (this.isPdf || this.isImage)
    },
    isCheck: function() { //是否为查看考生报名信息
      return this.$route.params.type === 'preview'
    }
  },
  methods: {
    upclick() {
      this.$emit("bindup");
    },
    testclick() {
      this.$emit("codeclick");
    },
    handleinput(event) {
      //父组件在绑定v-model时，其实就绑定的input事件，因此父组件不需要再声明事件了
      this.$emit("input", event.target.value);
    },
    clear() {
      this.$emit("input", "");
    },
    handlepwd() {
      this.passwordVisiable = !this.passwordVisiable;
    },
    preview() {
      this.previewFlag = true
      this.previewUrl = this.mainup
    },
    close() {
      this.previewFlag = false
      this.previewUrl = ''
    }
  },
};
</script>
<style lang="less" scoped>
.fileboxheader {
  position: relative;
  width: @fileboxw;
  height: @filebox;
  line-height: @filebox;

  border: @filexborder;
  background: @bluebtn;
  > span {
    color: @whitee;
    padding-left: @filepadding;
  }
  > img {
    position: absolute;
    right: @filepadding;
    top: 50%;
    width: @checkringht;
    transform: translateY(-50%);
  }
}
.fileboxmain {
  background: @globalback;
  width: @fileboxw;
  height: @fileboxmax;
  border: @filexborder;

  display: flex;
  justify-content: center;
  align-items: center;
}
.fileboxbox {
  text-align: center;
}
.fileboxtext {
  color: @bluebtn;
  font-size: @checkringht;
}
</style>
